import { n as e, t } from "./maplibre-CUYkxr-D.js";
import { t as n } from "./utils-CjIvvA5e.js";
import { useMemo as r } from "react";
import { Fragment as i, jsx as a } from "react/jsx-runtime";
//#region src/components/Map/Root/Layers/Maptiler/index.tsx
function o(e, t, n) {
	switch (e) {
		case "fill": return {
			"fill-color": t,
			"fill-opacity": .25
		};
		case "line": return {
			"line-color": t,
			"line-width": n === "LineString" ? 6 : 2
		};
		default: return {};
	}
}
function s({ sources: s }) {
	let c = r(() => !Array.isArray(s) || s.length === 0 ? [] : s.map((e) => ({
		...e,
		geoJson: e.geometry ? n(e.geometry, e.type) : null
	})), [s]);
	return c?.length === 0 ? null : /* @__PURE__ */ a(i, { children: c?.map((n) => /* @__PURE__ */ a("div", { children: n.geoJson && /* @__PURE__ */ a(e, {
		id: n.key,
		type: "geojson",
		data: n.geoJson,
		children: n.layer && (Array.isArray(n.layer) ? n.layer.map((e, r) => /* @__PURE__ */ a(t, {
			id: `${n.key}-${r}`,
			type: e.type,
			paint: o(e.type, e.color, n.type)
		}, `${n.key}-${r}`)) : /* @__PURE__ */ a(t, {
			id: n.key,
			type: n.layer.type,
			paint: o(n.layer.type, n.layer.color, n.type)
		}))
	}, n.key) }, n.key)) });
}
//#endregion
export { s as default };
